<template>
    <CModal title="Редатирование категории" :show.sync="dialogVisible">
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название категории"
            />

            <CInput
                v-model="model.from"
                :horizontal="true"
                label="Время работы с"
                placeholder="13:00"
            />

            <CInput
                v-model="model.to"
                :horizontal="true"
                label="Время работы по"
                placeholder="14:00"
            />
            <!-- <CRow class="pl-3">Работа по дням недели</CRow> -->
            <CCol
                cols="12"
                md="12"
                class="mt-1 mb-1 flex p-0">
                <span class="mr-2">Включать категорию по дням</span>
                <CSwitch
                    color="dark"
                    shape="pill"
                    variant="opposite"
                    :checked.sync="useWorkDays"
                />
            </CCol>
            <CRow v-if="useWorkDays">
                <template v-for="day in daysOfWeek">
                    <CCol :key="day.value" sm="1">
                        <CInputCheckbox
                            class="mb-0"
                            inline
                            :value="day.active"
                            :checked="day.active"
                            @update:checked="updateDay(day.value)"
                        />{{ day.label }}
                    </CCol>
                </template>
            </CRow>
            <CCol
                cols="12"
                md="12"
                class="mt-1 mb-1 flex p-0">
                <span class="mr-2">Активна</span>
                <CSwitch
                    color="dark"
                    shape="pill"
                    variant="opposite"
                    :checked.sync="model.enabled"
                />
            </CCol>
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>
            <CButton
                color="primary"
                class="ml-3"
                @click="submit">Сохранить</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'RestaurantCategoryUpsertDialog',

        props: {
            categoryId: {
                type: Number,
                default: null,
            },
        },

        data: () => ({
            dialogVisible: false,
            useWorkDays: false,
            daysOfWeek: [
                { label: 'Пн', value: 1, active: false },
                { label: 'Вт', value: 2, active: false },
                { label: 'Ср', value: 3, active: false },
                { label: 'Чт', value: 4, active: false },
                { label: 'Пт', value: 5, active: false },
                { label: 'Сб', value: 6, active: false },
                { label: 'Вс', value: 0, active: false },
            ],
            model: {},
        }),

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        watch: {
            dialogVisible: async function (v) {
                if (v) {
                    await this.fetchCategory(this.categoryId);
                }
            },
        },

        methods: {
            open() {
                this.dialogVisible = true;
            },

            close() {
                this.dialogVisible = false;
            },

            updateDay(val) {
                const dayIndex = this.daysOfWeek.findIndex(day => day.value === val);
                this.daysOfWeek[dayIndex] = { ...this.daysOfWeek[dayIndex], active: !this.daysOfWeek[dayIndex].active };
            },

            async fetchCategory(categoryId) {
                const id = this.$route.params.id;
                if (this.categoryId) {
                    const category = (await this.axios.get(`/restaurants/${id}/categories/${categoryId}`)).data;
                    if (category?.work_days?.length > 0) {
                        this.useWorkDays = true,
                        this.daysOfWeek = this.daysOfWeek.map(day => ({ ...day, active: category?.work_days?.includes(day.value) }));
                    }
                    this.model = category;
                }
            },

            async submit() {
                try {
                    const { ...payload } = this.model;
                    payload.from = payload.from ? payload.from : null;
                    payload.to = payload.to ? payload.to : null;
                    payload.work_days = this.useWorkDays ? this.daysOfWeek.filter(day => day.active).map(day => day.value) : [];
                    const id = this.$route.params.id;

                    if(payload.id) {
                        await this.axios.put(`/restaurants/${id}/categories/${payload.id}`, payload);
                    } else {
                        await this.axios.post(`/restaurants/${id}/categories`, payload);
                    }

                    this.$emit('success');
                    this.close();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка редактирования категории. ' + err);
                }
            },
        },
    };
</script>
